import React from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  if (isInitial) return null; // Removed initial section as it was merged into MetricsTestimonialsSection
  const testimonial = {
    initials: 'LF',
    name: 'Lucía Fernández',
    desc: 'Docente de nivel primario',
    quote: 'Con el Proyecto Primaria 360 los chicos dejaron de escaparse con el Mundial. Me seguían las consignas, discutían datos y los ejercicios de Lengua y Matemática quedaron integrados, no pegados. La planificación me salvó muchísimo tiempo.'
  };
  return <section className="py-10 md:py-16 px-4 md:px-6 bg-familia-bg" data-id="element-53">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-54">
        <div className="text-center mb-8 md:mb-10" data-id="element-55">
          <h2 className="text-[20px] sm:text-2xl md:text-3xl font-display font-extrabold mb-4" data-id="element-56">
            Docentes que ya transformaron el Mundial en aprendizaje
          </h2>
        </div>

        <div className="bg-familia-card border border-familia-gold shadow-[0_0_15px_rgba(215,168,62,0.2)] p-6 md:p-8 rounded-2xl flex flex-col" data-id="element-57">
          <div className="flex items-center gap-4 mb-4" data-id="element-58">
            <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg shrink-0 bg-familia-electric text-white" data-id="element-59">
              {testimonial.initials}
            </div>
            <div data-id="element-60">
              <div className="text-familia-gold text-xs mb-1" data-id="element-61">⭐⭐⭐⭐⭐</div>
              <div className="font-bold text-sm text-white" data-id="element-62">
                {testimonial.name}
              </div>
              <div className="text-familia-cyan text-[10px] uppercase tracking-wider" data-id="element-63">
                {testimonial.desc}
              </div>
            </div>
          </div>
          <p className="text-white/90 italic text-[14px] sm:text-base leading-relaxed flex-grow" data-id="element-64">
            "{testimonial.quote}"
          </p>
        </div>

        <div className="mt-6 text-center text-sm font-bold text-familia-cyan" data-id="element-65">
          <span data-id="element-66">500+ compradores · 4,9/5 de calificación</span>
        </div>
      </div>
    </section>;
};